var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"experience"},[_c('p',[_c('span',{staticClass:"title",class:_vm.strongTitle && 'title-strong'},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(_vm.subtitle)?_c('p',[_vm._v(_vm._s(_vm.subtitle)+" "+_vm._s(_vm.suffix))]):_vm._e(),_vm._v(" "),_c('p',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-970c2bb2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExperienceRow.vue
// module id = 747
// module chunks = 1